import React from "react";
import styles from "./MasterFile.module.scss";

import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";
import * as appConfig from "appConfig";
import { messages } from "../Delivery.messages";
import { useIntl } from "react-intl";
import { useUi } from "@jelly/lesson";

export const MasterFile: React.FC = () => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <div className={styles.container}>
      {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
      <SpatialCarousel showBreadcrumbs>
        {[
          <div key={1} className={styles.carouselItem}>
            <h3 className={styles.title}>{formatMessage(messages.masterFileTitle)}</h3>
            <ui.Scrollbars>
              <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.masterFileDescription1) }}></p>
              <div className={styles.imageContainer}>
                <img className={styles.image} src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/delivery/1.png`} />
              </div>
            </ui.Scrollbars>
          </div>,
          <div key={2} className={styles.carouselItem}>
            <h3 className={styles.title}>{formatMessage(messages.masterFileTitle)}</h3>
            <ui.Scrollbars>
              <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.masterFileDescription2) }}></p>
              <div className={styles.imageContainer}>
                <img className={styles.image} src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/delivery/2.png`} />
              </div>
              <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.masterFileDescription3) }}></p>
              <div className={styles.imageContainer}>
                <img className={styles.image} src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/delivery/3.png`} />
              </div>
            </ui.Scrollbars>
          </div>,
          <div key={3} className={styles.carouselItem}>
            <h3 className={styles.title}>{formatMessage(messages.masterFileTitle)}</h3>
            <ui.Scrollbars>
              <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.masterFileDescription4) }}></p>
              <div className={styles.imageContainer}>
                <img className={styles.image} src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/delivery/4.png`} />
              </div>
              <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.masterFileDescription5) }}></p>
              <div className={styles.imageContainer}>
                <img className={styles.image} src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/delivery/5.png`} />
              </div>
            </ui.Scrollbars>
          </div>,
        ]}
      </SpatialCarousel>
    </div>
  );
};
